import { showResponseMessage } from "../Components/utils/handellApiResponse";
import SettingsServices from "../api-services/settings-logs-sevrices";

export const createSettingsSlice = (set) => ({
  settings: {},
  settingsLoading: false,

  fetchSettingsFunction: async () => {
    set((state) => ({
      ...state,
      settingsLoading: true,
    }));
    try {
      const response = await SettingsServices.getSettings();
      set((state) => ({
        ...state,
        settings: response.data.data,
        settingsLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        settingsLoading: false,
      }));
    }
  },

  updateSettingsFunction: async (data) => {
    set((state) => ({
      ...state,
      settingsLoading: true,
    }));
    try {
      const response = await showResponseMessage(
        SettingsServices.updateSettings(data),
        "update"
      );
      
      set((state) => ({
        ...state,
        settings: response.data.data,
        settingsLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        settingsLoading: false,
      }));
    }
  },
});
